import React from 'react'
import { Tab, Tabs } from '@material-ui/core'

const AntTabs = ({ value, options=[], onChange=()=>{} }) => {
  return (
    <Tabs
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      textColor='primary'
      indicatorColor='primary'
      className='border-bottom mb-2'
    >
      {options.map(op => (
        <Tab
          key={op.value}
          value={op.value}
          label={op.label}
          disabled={op.disabled}
        />
      ))}
    </Tabs>
  )
}

export default AntTabs
